export default __webpack_public_path__ + "static/media/sand.b0b543b0.jpg";